<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon :color="color" v-on="on">{{ icon }}</v-icon>
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false
    }
  }
}
</script>

<docs>
**Toujours utiliser à la fin d'une _view_.**

Positionner des boutons d'actions dans le coin
inférieur droit de l'écran. 
Ceux-ci sont toujours visible.

``` html
<template>
  <v-container>
    <!-- Contenu -->
    <ui-action>
      <v-btn>Bouton #1</v-btn>
      <v-btn>Bouton #2</v-btn>
    </ui-action>
  </v-container>
</template>
```

</docs>
